import { createContext } from 'react';

const GeneralContext = createContext({
    characterName: 'Daniel',
    level: 5,
    levelUp: () => {}
});

export default GeneralContext;